<template>
    <form id="onboarding-de" class="wrapper wrapper-tab-last" role="form" method="post" @submit.prevent="submit()">
        <div v-if="showSurvey">      
            <header>
                <span class="headline-xlg">
                    <figure>
                        <svg width="40" height="40" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="30" cy="30" r="30" fill="#54DBA3"/>
                        <path d="M26.0875 43C25.3124 43 24.5675 42.6908 24.0182 42.138L10.8572 28.8935C9.71427 27.7433 9.71427 25.881 10.8572 24.7308C12.0001 23.5807 13.8507 23.5807 14.9936 24.7308L26.0875 35.8952L44.0064 17.8626C45.1494 16.7125 46.9999 16.7125 48.1428 17.8626C49.2857 19.0128 49.2857 20.8751 48.1428 22.0253L28.1569 42.138C27.6076 42.6908 26.865 43 26.0875 43Z" fill="white"/>
                        </svg>
                    </figure>
                    <span>Vielen Dank für Ihre Zeit!</span>
                </span>
                <span class="headline-xs text-color-default">Wo haben Sie von Vitadio erfahren?</span>
            </header>

            <div v-if="success" class="form-input-radio-button-wrapper">
                <p class="text-big text-bold text-green text-centered">Vielen Dank für Ihre Zeit!</p>

                <v-button href="/" position="center" size="lg" label="Ende"></v-button>
            </div>

            <div v-else class="form-input-radio-button-wrapper">
                <form-input-type-radio-button
                    v-for="(item, index) in survey"
                    :key="index"
                    :value="item"
                    @onClick="chooseSurvey(item)"
                    isSending
                ></form-input-type-radio-button>
            </div>
        </div>

        <div v-else>
            <header class="section-header">
                <figure>
                    <svg width="40" height="40" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="30" cy="30" r="30" fill="#54DBA3"/>
                    <path d="M26.0875 43C25.3124 43 24.5675 42.6908 24.0182 42.138L10.8572 28.8935C9.71427 27.7433 9.71427 25.881 10.8572 24.7308C12.0001 23.5807 13.8507 23.5807 14.9936 24.7308L26.0875 35.8952L44.0064 17.8626C45.1494 16.7125 46.9999 16.7125 48.1428 17.8626C49.2857 19.0128 49.2857 20.8751 48.1428 22.0253L28.1569 42.138C27.6076 42.6908 26.865 43 26.0875 43Z" fill="white"/>
                    </svg>
                </figure>
                <span class="headline-lg">Wir werden Sie so bald wie möglich oder zu der von Ihnen gewünschten Zeit telefonisch kontaktieren unter <span class="text-violet">030&nbsp;466&nbsp;900&nbsp;57</span>.</span>
            </header>

            <section>
                <v-button @onClick="showSurveyForm()" position="center" size="lg" label="Weiter" full-width></v-button>
                <p class="text-color-default">Wenn Sie keine Nachricht erhalten haben, wenden Sie sich bitte an <strong><a href="mailto:kontakt@vitadio.de">kontakt@vitadio.de</a></strong> oder telefonisch an <strong><a href="tel:015738289953">0157 382 899 53</a></strong>.</p>
            </section>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            data: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                choosenSurvey: null,
                survey: [
                    'Arztpraxis',
                    'Social Media',
                    'Presse',
                    'Anderes',
                    'Internet-Recherche',
                    'Diabetes&shy;berater*in',
                    'Familie oder Freunde',
                ],
                success: false,
                showSurvey: false
            }
        },

        mounted() {
            if(this.data.phone === null) {
                this.showSurveyForm()
            }
        },

        methods: {
            showSurveyForm() {
                this.showSurvey = true
                var refresh = window.location.protocol + "//" + window.location.host + window.location.pathname + '?step=7';   
                window.history.replaceState({ path: refresh }, '', refresh);
            },

            chooseSurvey(learnt_about_vitadio_from) {
                this.choosenSurvey = learnt_about_vitadio_from

                this.submit()
            },

            submit() {
                var formData = {}

                formData.learnt_about_vitadio_from = this.choosenSurvey
                
                axios
                    .post('api/web_pre_registration_form/'+this.data.id, formData, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((e) => {
                        this.success = true
                    })
                    .catch((e) => {
                        this.errors = e.response.data.errors
                        console.log(e.response)
                        Vuemit.fire('Button--sending-failed', true)
                    }) 
            }
        }
    }
</script>